import type { AppLanguage } from "./language";
import type { KnowledgeArticleStatus } from "./types";

export const knowledgeArticleStatusOrder: readonly KnowledgeArticleStatus[] = ["Draft", "Review", "Published"];

const knowledgeArticleStatusLabels: Record<AppLanguage, Record<KnowledgeArticleStatus, string>> = {
  en: {
    Draft: "Draft",
    Review: "Review",
    Published: "Published",
  },
  ja: {
    Draft: "下書き",
    Review: "レビュー中",
    Published: "公開済み",
  },
};

export function knowledgeArticleStatusLabel(status: KnowledgeArticleStatus, language: AppLanguage): string {
  return knowledgeArticleStatusLabels[language]?.[status] ?? status;
}

const knowledgeArticleStatusBadgeClasses: Record<KnowledgeArticleStatus, string> = {
  Draft: "bg-[#fef3f2] text-[#b42318] dark:bg-[#3a1212] dark:text-[#fda29b]",
  Review: "bg-[#fff6ed] text-[#b93815] dark:bg-[#3a1d0e] dark:text-[#f7b27a]",
  Published: "bg-[#ecfdf3] text-[#067647] dark:bg-[#0f2a1a] dark:text-[#75e0a7]",
};

export function knowledgeArticleStatusBadgeClass(status: KnowledgeArticleStatus): string {
  return knowledgeArticleStatusBadgeClasses[status] ?? "bg-[#f2f4f7] text-[#475467]";
}
